// Broker estaba asi id == 1 || id == 2
// export const onlyProductAccess = (channel, id) => {
//   switch (channel) {
//     case "vida": // No se muestra RG
//       return id == 1 || id == 2;

//     case "vidapiloto": // Si se muestra RG
//       return id == 2;

//     case "tlmkt":
//       return id == 2;

//     case "broker": // Se muestra todo
//       return id == 2;

//     case "emisor": // Se muestra todo
//       return id == 1 || id == 2;

//     case "renta": // Se muestra todo
//       return id == 1 || id == 2;

//     default:
//       return false;
//   }
// };

// export const onlyLinkSimulatesAccess = (channel) => {
//   switch (channel) {
//     case "vida":
//       return true;

//     case "vidapiloto":
//       return true;

//     case "tlmkt":
//       return true;

//     case "admin":
//       return true;

//     case "renta":
//       return true;

//     case "suscript":
//       return false;

//     case "broker":
//       return true;
    
//     case "emisor":
//       return true;

//     default:
//       return false;
//   }
// };

// export const onlyLinkQuotesAccess = (channel) => {
//   switch (channel) {
//     case "vida":
//       return true;
    
//     case "vidapiloto":
//       return true;

//     case "tlmkt":
//       return true;

//     case "renta":
//       return true;

//     case "admin":
//       return true;

//     case "suscript":
//       return false;

//     case "broker":
//       return true;

//     case "emisor":
//       return true;

//     default:
//       return false;
//   }
// };

// export const onlyLinkAprovationsAccess = (channel) => {
//   switch (channel) {
//     case "vida":
//       return false;

//     case "vidapiloto":
//       return false;

//     case "tlmkt":
//       return false;

//     case "renta":
//       return false;

//     case "admin":
//       return true;

//     case "suscript":
//       return true;

//     case "broker":
//       return false;

//     case "emisor":
//       return true;

//     default:
//       return false;
//   }
// };

// export const onlyLinkProductsAccess = (channel) => {
//   switch (channel) {
//     case "vida":
//       return true;

//     case "vidapiloto":
//       return true;

//     case "tlmkt":
//       return true;

//     case "renta":
//       return true;

//     case "admin":
//       return true;

//     case "suscript":
//       return false;

//     case "broker":
//       return true;

//     case "emisor":
//       return true;

//     default:
//       return false;
//   }
// };


export const extractModuleFromPath = (path = '') => {
  const segments = path.split('/').filter(Boolean);
  return segments[0] || '';
};

export const showModulesAccess = (modules = [], path = '') => {
  const routeModule = extractModuleFromPath(path);
  return modules.includes(routeModule);
};

// export const validateUSer = (e) =>
//   e === process.env.REACT_APP_ROL_ADMIN ||
//   e === process.env.REACT_APP_ROL_RENTA ||
//   e === process.env.REACT_APP_ROL_VIDA ||
//   e === process.env.REACT_APP_ROL_TLMKT ||
//   e === process.env.REACT_APP_ROL_SUSCRIPTOR ||
//   e === process.env.REACT_APP_ROL_BROKER;
